module.exports = __webpack_public_path__ + "static/media/Picture2.9ca75294.jpg";